<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible">
    <el-form :model="form">
      <el-form-item class="warn-info">
        <i class="iconfont iconjinggao"></i>
        <span v-html="warnInfo"></span>
      </el-form-item>
      <el-form-item v-if="tipStatus" label="白名单ip" :label-width="formLabelWidth">
        <el-input v-model="form.ip" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm" :disabled="!disabled">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogFormVisible: false,
      form: {
        ip: '',
        createTime: new Date(),
      },
      formLabelWidth: '80px',
      title: '操作提示',
      warnInfo: '',
      tipStatus: false,
      row: {},
      success: () => {},
    };
  },
  computed: {
    disabled() {
      return Boolean(this.form.ip);
    },
  },
  methods: {
    submitForm() {
      this.success(this.form);
      this.cancel();
    },
    cancel() {
      this.$destroy();
      this.$el.parentNode.removeChild(this.$el);
    },
  },
  mounted() {
    if (this.row != undefined) {
      this.form.ip = this.row.ip;
    }
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
// 重写 element-ui 样式
/deep/.el-dialog__body {
  padding-bottom: 0;
  padding-top: 10px;
}
/deep/.el-dialog {
  width: 426px;
  min-height: 194px;
  border: 5px;
}
.warn-info {
  .flex_layout(row, flex-start, center);
  .iconfont {
    color: #ff9f07;
    margin-right: 0.5em;
    margin-left: 0.4em;
  }
  /deep/p {
    margin: 0;
    font-size: @base-font-size;
  }
}
.footer {
  .flex_layout(row, flex-end, flex-end);
  padding-bottom: 1em;
  margin-bottom: 0;
}
/deep/.el-button {
  width: 56px;
  height: 32px;
  padding: 0;
  font-size: 12px;
}
.remark {
  margin-top: 1em;
}
</style>
